module.exports = __webpack_public_path__ + "img/GrottaHouse_Web_poster.50aba533.jpg";